<template>
  <v-container fluid>
      <v-layout justify-center>
          <v-flex md8>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-flex>
      </v-layout>
      <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="main" :urls="urls" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import router from '@/router'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: '03-0201' }
        ],
        titles: [
          { text: 'Clave', value: 'slug', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          // { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          // { text: 'Fecha Actualizada', value: 'Updated' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-border-color', color: 'yellow darken-2', action: 'toEditData', code: '03-0202' },
          { title: 'asignar Permisos', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'permissionsAssign', code: '03-0203' }
        ]
      },
      footer: {
        paging: true
      }
    },
    main: {},
    form: [],
    urls: '',
    message: ''
  }),
  components: {
    DataTableMain,
    MainFormDialog
  },
  mounted () {
    this.PostListObjects({ url: '/auth/roles' })
    this.ShowPermisos(JSON.parse(localStorage.getItem('permisos')))
  },
  methods: {
    ...mapActions(['PostListObjects']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.PostListObjects({ url: '/auth/roles' })
    },
    newData (item) {
      this.main = {}
      this.form = this.get_RolesForm
      this.urls = '/auth/roles/store'
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Rol' })
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    toEditData (item) {
      this.main = item
      this.form = this.get_RolesForm
      this.urls = `/auth/roles/${item.id}`
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'update', with: 850, title: 'Editar Rol' })
    },
    permissionsAssign (item) {
      router.push({ name: 'ViewPermissionsRoleAssign', params: { id: item.id } })
    },
    ShowPermisos (permisos) {
      if (permisos.descripcion) {
        if (permisos.descripcion.special === 'all-access') {
          this.table.header.options.map(action => {
            action.hidden = ''
          })
          this.table.body.actions.map(action => {
            action.hidden = ''
          })
          return
        }
      }
      this.table.header.options.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })

      this.table.body.actions.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })
    },
    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_objects',
      'get_RolesForm'])
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  }
}
</script>

<style>
